module.exports = __webpack_public_path__ + "img/20200515_opportunity-for-education-industry-digital-transformation.d3e64f1e.jpg";